/* istanbul ignore file */
export const DOCUMENT_TEMPLATE_CONSTANTS = {
    GRID_COLUMNS_TOKEN: ' | Cols: ',
    SITE_NO_FIELD_ID: 'siteNo'
};
